export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6038.864c39e6.jpg";